import { styled } from '@mui/material/styles';
import { ListItem } from 'shared/mui/List';

export const NotificationPopperListItem = styled(ListItem)(({ theme }) => ({
  alignItems: 'flex-start',
  padding: '16px 24px 16px 16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
